import { Cohort, PageVersions } from 'root-constants'
import { TPageVersion, TPartialMapWithDefault } from 'root-types'

export const LOADER_VERSION_BY_COHORT_KARMA = {
  [Cohort.KP_BS_7_WTYPE_C]: PageVersions.V2,
  [Cohort.KP_BS_7_WTYPE]: PageVersions.V2,
  [Cohort.KP_BS_7_TCHMNTR_C]: PageVersions.V3,
  [Cohort.KP_BS_13_C]: PageVersions.V1,
  [Cohort.KP_BS_13_H]: PageVersions.V1,
  default: PageVersions.V1,
} as const satisfies TPartialMapWithDefault<Cohort, TPageVersion>

export const SPEECH_BUBBLE_LONG_TEXT_LENGTH = 15
